/* ft-teilefinder.js (14.10.2026 abends, Sitzung Webshop, Testshop-Umbau): Verhalten des EINEN Teilefinders
   (snippets/ft-teilefinder, im Kopf: Suchfenster in sections/ft-header). Braucht assets/ft-teile.js (FtTeile) und
   snippets/ft-fahrzeug-speicher (FtFahrzeug).
   - Beim Tippen steht unter dem Feld, was erkannt wurde: Schlüsselnummer (mit dem Fahrzeug laut Fahrzeugdaten), Teilenummer,
     Fahrzeug. Abgeschickt wird immer an /search; dort entscheidet assets/ft-treffer.js.
   - „Fahrzeug auswählen“ klappt Marke, Modell, Motor auf (snippets/ft-kat-fahrzeugwahl, assets/ft-fzwahl.js).
   - Gemerktes Fahrzeug oben mit „Teile anzeigen“, „Ändern“ und ✕. */
(function () {
  function los() {
    var T = window.FtTeile, F = window.FtFahrzeug;
    if (!T) return;
    var esc = T.esc;
    var HAKEN = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';

    function einrichten(box) {
      if (box.hasAttribute('data-tf-an')) return;
      box.setAttribute('data-tf-an', '');
      /* Ein Hinweis auf das gemerkte Fahrzeug je Seite: Steht ein Teilefinder in der Seite (nicht nur im Suchfenster), zeigt er das
         Fahrzeug mit „Teile anzeigen“, die schmale Leiste unter dem Kopf (snippets/ft-mein-fahrzeug-leiste) tritt dann zurück. */
      if (!box.closest('.ft-search-overlay')) document.documentElement.classList.add('ft-hat-teilefinder');
      /* 15.10.2026: mit Reitern steht vor dem Nummernfeld das versteckte q des HSN/TSN-Formulars, deshalb das sichtbare Feld nehmen */
      var feld = box.querySelector('.ft-tf-input') || box.querySelector('input[name="q"]');
      var erkannt = box.querySelector('[data-tf-erkannt]');
      var mein = box.querySelector('[data-tf-mein]');
      var knopf = box.querySelector('[data-tf-wahl-knopf]');
      var wahl = box.querySelector('[data-tf-wahl]');
      var nr = 0, timer = null;
      /* Alte Adressen der Markenseite mit Fahrzeug (?modell=…&motor=…, bis 14.10. von FtFahrzeug.url gebaut) zeigen jetzt die
         Trefferseite, wie jede andere Fahrzeugwahl */
      var vorMarke = box.getAttribute('data-tf-marke');
      if (vorMarke) {
        var pp = new URLSearchParams(location.search);
        if (pp.get('modell') && pp.get('motor')) {
          T.marke(vorMarke).then(function (d) {
            if (!d) return;
            location.replace(T.ergebnisUrl({ marke: d.marke, modell: pp.get('modell'), motor: pp.get('motor'), ps: pp.get('ps') || '', ccm: pp.get('ccm') || '', jahre: pp.get('jahre') || '' }));
          });
        }
      }

      function zeigen(html, art) {
        if (!erkannt) return;
        if (!html) { erkannt.hidden = true; erkannt.innerHTML = ''; erkannt.removeAttribute('data-art'); return; }
        erkannt.innerHTML = html;
        erkannt.setAttribute('data-art', art || '');
        erkannt.hidden = false;
      }
      function pruefen() {
        var q = feld.value.trim();
        var a = T.art(q);
        var meine = ++nr;
        if (a.typ === 'leer') return zeigen('');
        if (a.typ === 'hsn') {
          zeigen(HAKEN + '<span>Schlüsselnummer erkannt: HSN <strong>' + esc(a.hsn) + '</strong>, TSN <strong>' + esc(a.tsn) + '</strong></span>', 'hsn');
          T.hsnFahrzeuge(a.code).then(function (r) {
            if (meine !== nr) return;
            var f = r.fahrzeuge;
            if (f.length === 1) zeigen(HAKEN + '<span>Schlüsselnummer ' + esc(a.hsn + ' ' + a.tsn) + ': laut Fahrzeugdaten <strong>' + esc(T.fahrzeugText(f[0], false)) + '</strong></span>', 'hsn');
            else if (f.length > 1) zeigen(HAKEN + '<span>Schlüsselnummer ' + esc(a.hsn + ' ' + a.tsn) + ': laut Fahrzeugdaten <strong>' + f.length + ' Fahrzeuge</strong>, Sie wählen auf der nächsten Seite</span>', 'hsn');
            else zeigen('<span>Schlüsselnummer ' + esc(a.hsn + ' ' + a.tsn) + ': in unseren Fahrzeugdaten nicht gefunden. Suchen Sie trotzdem, oder wir prüfen es kostenlos.</span>', 'leer');
          });
          return;
        }
        if (a.typ === 'nummer') {
          if (a.kurz) return zeigen('<span>Nummernanfang: Sie sehen alle Teile, deren Nummer so beginnt.</span>', 'nummer');
          return zeigen(HAKEN + '<span>Teilenummer erkannt: <strong>' + esc(a.nummer) + '</strong></span>', 'nummer');
        }
        if (q.length < 3) return zeigen('');
        T.fahrzeugImText(q).then(function (e) {
          if (meine !== nr) return;
          if (!e) return zeigen('');
          var name = T.markeSchoen(e.marke.name);
          if (e.nurMarke) return zeigen(HAKEN + '<span>Marke erkannt: <strong>' + esc(name) + '</strong>. Modell dazuschreiben oder Fahrzeug auswählen.</span>', 'fahrzeug');
          var x = e.modelle[0];
          var modell = T.kurzName(x.m.n, e.marke.kennung);
          if (e.modelle.length > 1) {
            var basis = modell.split(' ').slice(0, 2).join(' ');
            modell = basis;
          }
          var motor = e.motor ? ', ' + (T.motorNamen({ m: x.m, motoren: x.motoren })[0] || '') : '';
          zeigen(HAKEN + '<span>Fahrzeug erkannt: <strong>' + esc(name + ' ' + modell + (e.modelle.length === 1 ? motor : '')) + '</strong>' +
            (e.modelle.length > 1 ? ', ' + e.modelle.length + ' Modelle zur Wahl' : '') + '</span>', 'fahrzeug');
        });
      }
      if (feld) {
        feld.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(pruefen, 220); });
        if (feld.value.trim() && !box.classList.contains('ft-tf--treffer')) pruefen();
      }

      /* Produktseite (data-tf-bleiben): Schlüsselnummer und Fahrzeug werden hier gemerkt, die Seite bleibt. Teilenummern gehen wie überall
         zur Trefferseite (Formular wird normal abgeschickt). */
      var form = feld ? feld.form : box.querySelector('form');
      if (box.hasAttribute('data-tf-bleiben') && form && feld) {
        form.addEventListener('submit', function (ev) {
          var a = T.art(feld.value.trim());
          if (a.typ === 'nummer' || a.typ === 'leer') return;
          ev.preventDefault();
          clearTimeout(timer);
          var meine = ++nr;
          if (a.typ !== 'hsn') {
            zeigen('<span>Bitte wählen Sie Ihr Fahrzeug unten aus: Marke, Modell, Motor.</span>', 'fahrzeug');
            wahlAuf(true);
            return;
          }
          var hsnText = a.hsn + ' ' + a.tsn;
          zeigen('<span>Schlüsselnummer ' + esc(hsnText) + ': Fahrzeug wird in unseren Fahrzeugdaten gesucht.</span>', 'hsn');
          T.hsnFahrzeuge(a.code).then(function (r) {
            if (meine !== nr) return;
            var f = r.fahrzeuge;
            if (!f.length) {
              zeigen('<span>Zu dieser Schlüsselnummer haben wir in unseren Fahrzeugdaten kein Fahrzeug. Wählen Sie Ihr Fahrzeug unten aus, oder wir prüfen es kostenlos: ' +
                '<a class="ft-link" href="' + esc(T.waLink('Hallo Fair-Turbo, bitte prüft, ob der Artikel zu meiner HSN/TSN ' + hsnText + ' passt: ' + location.href)) + '" target="_blank" rel="noopener noreferrer">per WhatsApp</a>.</span>', 'leer');
              return;
            }
            var knoepfe = f.map(function (v, i) {
              return '<button type="button" class="ft-tf-hsn-ja" data-tf-hsn="' + i + '">' + (f.length === 1 ? 'Ja, Fahrzeug merken' : esc(T.fahrzeugText(v, true))) + '</button>';
            }).join('');
            zeigen('<span>' + (f.length === 1
              ? 'Laut Fahrzeugdaten gehört diese Schlüsselnummer zu: <strong>' + esc(T.fahrzeugText(f[0], true)) + '</strong>. Stimmt das?'
              : 'Laut Fahrzeugdaten gehört diese Schlüsselnummer zu einem dieser Fahrzeuge. Welches ist Ihres?') +
              '<span class="ft-tf-hsn-knoepfe">' + knoepfe + '</span></span>', 'hsn');
            [].forEach.call(erkannt.querySelectorAll('[data-tf-hsn]'), function (b) {
              b.addEventListener('click', function () {
                var v = f[parseInt(b.getAttribute('data-tf-hsn'), 10)];
                v.hsntsn = a.code;
                if (F) F.schreiben(v);
                zeigen(HAKEN + '<span>Gemerkt: <strong>' + esc(T.fahrzeugText(v, true)) + '</strong>.</span>', 'hsn');
              });
            });
          });
        });
      }

      function wahlAuf(auf) {
        if (!knopf || !wahl) return;
        knopf.setAttribute('aria-expanded', auf ? 'true' : 'false');
        wahl.hidden = !auf;
        if (auf) { var s = wahl.querySelector('select:not([disabled])'); if (s && !window.matchMedia('(max-width: 749px)').matches) s.focus(); }
      }
      if (knopf) knopf.addEventListener('click', function () { wahlAuf(knopf.getAttribute('aria-expanded') !== 'true'); });

      function meinZeigen(v) {
        if (!mein) return;
        if (!v) { mein.hidden = true; mein.innerHTML = ''; box.classList.remove('hat-fahrzeug'); return; }
        mein.innerHTML = '<span class="ft-tf-mein-haken" aria-hidden="true">' + HAKEN + '</span>' +
          '<span class="ft-tf-mein-text">Ihr Fahrzeug: <strong>' + esc(T.fahrzeugText(v, false)) + '</strong></span>' +
          '<span class="ft-tf-mein-aktionen"><a class="ft-tf-mein-los" href="' + esc(T.ergebnisUrl(v)) + '">Teile anzeigen</a>' +
          '<button type="button" class="ft-tf-mein-aendern" data-tf-aendern>Ändern</button>' +
          '<button type="button" class="ft-tf-mein-weg" data-tf-weg aria-label="Fahrzeug vergessen"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button></span>';
        mein.hidden = false;
        box.classList.add('hat-fahrzeug');
        passend(v);
      }
      /* Kategorie-Seiten: Zahl der Teile dieser Gruppe, die laut Fahrzeugdaten zum gemerkten Fahrzeug gehören, und der Weg dorthin */
      var NAMEN = { L: ['Turbolader', 'Turbolader'], K: ['Set', 'Sets'], M: ['Montagesatz', 'Montagesätze'], Z: ['Zubehörteil', 'Zubehörteile'],
        O: ['Öl- oder Wasserleitung', 'Öl- und Wasserleitungen'], H: ['Schlauch', 'Schläuche'], E: ['Sensor', 'Sensoren'], AK: ['Stellmotor', 'Stellmotoren'], ALLE: ['Teil', 'Teile'] };
      /* Kürzel der Kategorie zur Art in den Fahrzeugdaten (assets/ft-teile.js ARTNAME); L, K, M, Z sind Gruppen */
      var EINZEL = { O: 'O', H: 'H', E: 'E', AK: 'A' };
      function passend(v) {
        var gruppe = box.getAttribute('data-tf-gruppe');
        if (!gruppe || !NAMEN[gruppe] || !v) return;
        var meiner = v;
        T.marke(T.slug(v.marke)).then(function (d) {
          if (meiner !== v || !mein || mein.hidden) return;
          var z = d && T.zeileFinden(d, v);
          if (!z) return;
          var teile = T.teileVon(d, z.motor);
          /* 15.10.2026 abends: „Zubehör“ ist auf der Trefferseite keine eigene Gruppe mehr (assets/ft-teile.js), Z zählt alle Arten der Kategorie Zubehör */
          var n = gruppe === 'ALLE' ? teile.length : teile.filter(function (t) {
            return EINZEL[gruppe] ? t.art === EINZEL[gruppe] : (gruppe === 'Z' ? (T.ZUBEHOER || ['Z']).indexOf(t.art) > -1 : T.gruppeVon(t.art).code === gruppe);
          }).length;
          var los = mein.querySelector('.ft-tf-mein-los');
          var text = mein.querySelector('.ft-tf-mein-text');
          if (!los || !text) return;
          if (n) {
            /* 1 passender Turbolader, 1 passendes Set, 1 passender Montagesatz, 1 passendes Zubehörteil, 1 passendes Teil */
            var endung = n === 1 ? { L: 'r', K: 's', M: 'r', Z: 's', O: '', H: 'r', E: 'r', AK: 'r', ALLE: 's' }[gruppe] : '';
            los.textContent = n + ' passende' + endung + ' ' + NAMEN[gruppe][n === 1 ? 0 : 1] + ' zeigen';
            los.href = T.ergebnisUrl(v, gruppe !== 'ALLE' ? { art: gruppe } : null);
          } else {
            text.insertAdjacentHTML('beforeend', '<span class="ft-tf-mein-leer"> In dieser Kategorie ist dafür laut Fahrzeugdaten nichts hinterlegt.</span>');
            los.textContent = 'Alle Teile dafür (' + teile.length + ')';
          }
        });
      }
      if (mein && F) {
        meinZeigen(F.lesen());
        window.addEventListener('ft-fahrzeug', function (e) { meinZeigen(e.detail); });
        mein.addEventListener('click', function (e) {
          if (e.target.closest('[data-tf-weg]')) F.loeschen();
          else if (e.target.closest('[data-tf-aendern]')) wahlAuf(true);
        });
      }
    }

    /* Trefferseite: das Suchfeld im Kopf zeigt die Eingabe des Kunden (qo, sonst q ohne Filter-Marken), das Suchfenster ist damit vorbelegt */
    (function () {
      if (location.pathname.indexOf('/search') !== 0) return;
      var pp = new URLSearchParams(location.search);
      var e = (pp.get('qo') || (pp.get('q') || '').split(/\s+/).filter(function (t) { return t.indexOf(':') === -1; }).join(' ')).replace(/\*/g, '').trim();
      var pill = document.getElementById('ft-search-open');
      var feld = document.getElementById('ft-search-input');
      if (!e || !pill) return;
      var t = pill.querySelector('.ft-search-text strong');
      if (t) t.textContent = e;
      pill.classList.add('hat-wert');
      if (feld && !feld.value) feld.value = e;
    })();
    function alle() { [].forEach.call(document.querySelectorAll('[data-ft-tf]'), einrichten); }
    alle();
    window.FtTeilefinder = { einrichten: einrichten, alle: alle };
  }
  if (window.FtTeile) los(); else window.addEventListener('ft-teile-bereit', los, { once: true });
})();
